<div
    class="cmps-cdk-border-radius-4px cmps-cdk-bg-color-white cmps-uik-box-shadow-200 cmps-cdk-p-1 cmps-cdk-d-flex cmps-cdk-cg-1"
>
    <div class="cmps-cdk-flex-50">
        <div
            class="cmps-cdk-text-uppercase cmps-cdk-letter-spacing-0dot05 cmps-cdk-font-bold cmps-cdk-color-grey-400"
        >
            Start Date
        </div>
        <div class="cmps-cdk-d-flex">
            <div class="cmps-cdk-flex-grow-1">
                <input
                    class="cmps-form-input cmps-cdk-bg-color-transparent"
                    cmpsDateTimePicker
                    [onlyDate]="true"
                    name="startDate"
                    [ngModel]="_state.viewParams.rawStartDate"
                    (ngModelChange)="
                        _state.viewParams.rawStartDate = $event; _onChange(true)
                    "
                    #dpStartDate="cmpsDateTimePicker"
                />
            </div>
            <div>
                <button
                    type="button"
                    class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-h-34px cmps-cdk-w-34px"
                    [attr.aria-expanded]="dpStartDate.isOpen()"
                    (click)="$event.stopPropagation(); dpStartDate.toggle()"
                >
                    <cmps-icon svgIcon="calendar-range"></cmps-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="cmps-cdk-flex-50">
        <div
            class="cmps-cdk-text-uppercase cmps-cdk-letter-spacing-0dot05 cmps-cdk-font-bold cmps-cdk-color-grey-400"
        >
            End Date
        </div>
        <div class="cmps-cdk-d-flex">
            <div class="cmps-cdk-flex-grow-1">
                <input
                    class="cmps-form-input cmps-cdk-bg-color-transparent"
                    cmpsDateTimePicker
                    [onlyDate]="true"
                    name="endDate"
                    [ngModel]="_state.viewParams.rawEndDate"
                    (ngModelChange)="
                        _state.viewParams.rawEndDate = $event; _onChange(false)
                    "
                    #dpEndDate="cmpsDateTimePicker"
                />
            </div>
            <div>
                <button
                    type="button"
                    class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-h-34px cmps-cdk-w-34px"
                    [attr.aria-expanded]="dpEndDate.isOpen()"
                    (click)="$event.stopPropagation(); dpEndDate.toggle()"
                >
                    <cmps-icon svgIcon="calendar-range"></cmps-icon>
                </button>
            </div>
        </div>
    </div>
</div>
